import { Injectable } from "@angular/core";
import { ApiService } from "./api-service";
import { map } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ApplicationService {
  constructor(private api: ApiService, private httpClient: HttpClient) { }

  addApplication(body) {
    const url = "/application";
    return this.api.post(url, body);
  }

  updateApplication(id, body) {
    const url = `/application/${id}`;
    return this.api.put(url, body);
  }

  updateApplicationStatus(id, body) {
    const url = `/application/${id}/status`;
    return this.api.patch(url, body);
  }

  getApplicationsByApplicant(id) {
    const url = `/applicant/${id}/applications`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  getApplications(id) {
    const url = `/applicant/${id}/applications`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  getApplicationDetails(id) {
    const url = `/application/${id}`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  getApplicationTimeline(applicationID: string) {
    const url = `/application/${applicationID}/timeline`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  deleteApplications(id) {
    const url = `/application/${id}`;
    return this.api.delete(url);
  }

  addLaboratoryResults(applicationId, resultType, files) {
    const formData: FormData = new FormData();

    formData.append("ResultType", resultType.toString());

    files.forEach((file, index) => {
      formData.append("Files", file, file.name);
    });

    const url = `/applications/${applicationId}/labresults`;

    return this.api.post(url, formData);
  }

  getLaboratoryResults(applicationId) {
    const url = `/applications/${applicationId}/labresults/`;
    return this.api.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  bizpassLogin() {
    let body = {
      username: "b0$$",
      password:
        "c1349d11e33f9f573a7c0d02d61d5031331d7c69083b0e62924c537d7386970f",
    };
    const url = `https://bizpass.baguio.gov.ph/api/auth/login`;

    return this.httpClient.post(url, body);
  }

  bizpassSearchPTR(payor: string, or_number: string, token) {
    let body = {
      payor: `${payor}`,
      or_num: `${or_number}`,
    };
    const url = `https://bizpass.baguio.gov.ph/api/payment/other-fees/ptr`;

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      }),
    };

    return this.httpClient.post(url, body, httpOptions);
  }

  bizzpassSearchCedula(or_no: string, token) {
    let body = {
      or_no: `${or_no}`,
    };
    const url = `https://bizpass.baguio.gov.ph/api/payment/other-fees/ctc`;

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      }),
    };

    return this.httpClient.post(url, body, httpOptions);
  }

  searchReceipt(applicationId, body) {
    // const url = `/OfficialReceipt/Application/`${applicationId}/search`;
    const url = `/OfficialReceipt/Application/${applicationId}/search/`;
    return this.api.post(url, body);

  }

  hsoLaboratoryStatus(applicationId, labResultId) {
    const url = `/applications/${applicationId}/labresults/${labResultId}/status/hso-lab`;
    return this.api.put(url, {});
  }

  applicantResubmit(applicationId) {
    const url = `/application/${applicationId}/reset-status`;
    return this.api.patch(url, '');
  }

  updateApplicantDetails(applicationId: string, updatedDetails: any) {
    const url = `${environment.apiUrl}/application/${applicationId}`;
    return this.httpClient.put(url, updatedDetails);
  }
  
}
